import { EClientPath } from '~/models/api'

export type TCustomOAuthState = {
  signInRedirectPath: EClientPath
}

export type TNavigateState = {
  isPartnerThemed?: boolean
}

export enum ECognitoGroups {
  admin = 'admin',
  customerBasicPlan = 'customerBasicPlan',
  customerFreePlan = 'customerFreePlan',
  customerPlusPlan = 'customerPlusPlan',
  customerBasicFreeTrialPlan = 'customerBasicFreeTrialPlan',
  syd = 'syd',
  user = 'user',
  test = 'test',
  partnerAdmin = 'partnerAdmin',
  partnerEditor = 'partnerEditor',
}

export const userTiersByPrecedence: { [x in ECognitoGroups]?: number } = {
  [ECognitoGroups.customerFreePlan]: 0,
  [ECognitoGroups.customerBasicPlan]: 1,
  [ECognitoGroups.customerBasicFreeTrialPlan]: 1,
  [ECognitoGroups.customerPlusPlan]: 2,
}

export enum EAuthErrorName {
  CodeMismatchException = 'CodeMismatchException',
  ExpiredCodeException = 'ExpiredCodeException',
  UserNotConfirmedException = 'UserNotConfirmedException',
  UserNotFoundException = 'UserNotFoundException',
}
